/* import __COLOCATED_TEMPLATE__ from './suggestion-subtopics-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';

interface Args {
  contentWrapper: ContentWrapper;
}

const MAX_SUBTOPICS_SHOWN = 3;

export default class SuggestionSubtopicsCell extends Component<Args> {
  @service declare intl: IntlService;

  get subtopics() {
    let suggestionMetadata = this.args.contentWrapper.contentReviewSuggestionMetadata;
    if (suggestionMetadata?.subtopics) {
      return suggestionMetadata?.subtopics;
    }
    return [];
  }

  get moreSubtopics() {
    if (this.subtopics.length > MAX_SUBTOPICS_SHOWN) {
      return this.subtopics.slice(MAX_SUBTOPICS_SHOWN);
    }
    return [];
  }

  get suggestionSubtopics() {
    if (this.subtopics.length > MAX_SUBTOPICS_SHOWN) {
      return this.subtopics.slice(0, MAX_SUBTOPICS_SHOWN);
    }
    return this.subtopics;
  }

  get overflownText() {
    if (this.subtopics.length > MAX_SUBTOPICS_SHOWN) {
      return this.intl.t(
        'ai-content-library.content-reviews.list.cells.suggestion-subtopic.overflow',
        {
          numOverflowSubtopics: this.subtopics.length - MAX_SUBTOPICS_SHOWN,
        },
      );
    }
    return '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::List::Cells::SuggestionSubtopicsCell': typeof SuggestionSubtopicsCell;
  }
}
